import styled, { css } from 'styled-components';
import { breakpoint } from '../theme/breakpoint';
import { generateBackgroundImages } from '../styled/background-image';

const imageSizes = {
  mobileSmall: [326, 304],
  mobile: [479, 446],
  mobileLand: [608, 566],
  tablet: [352, 327],
  desktop: [412, 383],
};

export const ImageHolder = styled.div`
  height: 100%;
  background-size: cover;
  background-position: center;
  padding-top: 93%;
  ${({ $image: image }) =>
    image && generateBackgroundImages({ image, imageSizes, size: 'mobile' })};

  ${breakpoint.mobile`
    ${({ $image: image }) =>
      image && generateBackgroundImages({ image, imageSizes, size: 'mobile' })};
  `}

  ${breakpoint.mobileLand`
    ${({ $image: image }) =>
      image &&
      generateBackgroundImages({ image, imageSizes, size: 'mobileLand' })};
  `}

  ${breakpoint.tablet`
    ${({ $image: image }) =>
      image && generateBackgroundImages({ image, imageSizes, size: 'tablet' })};
  `}

  ${breakpoint.desktop`
    ${({ $image: image }) =>
      image &&
      generateBackgroundImages({ image, imageSizes, size: 'desktop' })};
  `}
`;

export const Wrapper = styled.div`
  padding: ${({ theme }) => `${theme.spacing.standard} 0`};

  background: ${({ $backgroundColor, theme }) =>
    ($backgroundColor === 'grey' && theme.palette.lightBackground) ||
    ($backgroundColor === 'white' && theme.palette.white)};

  margin-bottom: ${({ $removeMarginBottom, theme }) =>
    $removeMarginBottom ? '0' : theme.spacing.large};

  ${({ $overlayPaddingBottom, theme }) =>
    $overlayPaddingBottom &&
    `padding-bottom: ${theme.spacing.xlarge} !important`};

  ${breakpoint.tablet`
    padding: ${({ theme }) => `${theme.spacing.medium} 0`};
  `};
`;

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${breakpoint.tablet`
    flex-direction: row;
  `};
`;

export const LeftColumn = styled.div`
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  ${breakpoint.tablet`
    padding: ${({ theme }) => `0 ${theme.spacing.standard}`};
    width: 40%;
  `};
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;

  h3 {
    font-weight: ${({ theme }) => theme.fontWeight.bold};
  }

  ${({ $primaryBrandHero }) =>
    $primaryBrandHero &&
    css`
      justify-content: center;
    `};

  ${breakpoint.tablet`
    padding: ${({ theme }) =>
      `0 ${theme.spacing.standard} 0 ${theme.spacing.medium}`};
    width: 60%;
  `};
`;

export const Title = styled.p`
  margin-top: ${({ theme }) => theme.spacing.standard};

  // linebreak in the title on mobile & tablet only
  br {
    display: none;

    ${breakpoint.desktop`
      display: block;
    `};
  }

  ${breakpoint.tablet`
    margin-top: 0;
  `};
`;

export const BodyTextWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.xlarge};

  &:last-child {
    margin-bottom: 0;
  }

  > div > *:last-child {
    margin-bottom: 0;
  }
`;

export const CTAWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.standard};

  ${breakpoint.tablet`
    margin-bottom: 0;
  `};
`;
